import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { useStyles } from './styles';
const ButtonFork = ({ parentUrl }) => {
    const ownClasses = useStyles();
    return (React.createElement("a", { href: `/${parentUrl}`, className: ownClasses.root, target: "_blank", rel: "noreferrer" },
        React.createElement(Icon, { icon: ['fal', 'network-wired'], className: ownClasses.icon })));
};
export default ButtonFork;
